import React, { ReactNode } from "react";

export type ItemBaseProps = {
  isSelected?: boolean;
  id?: string | number;
  children?: ReactNode;
  subHeader?: boolean;
  [key: string]: any;
};

export const ItemBase = (props: ItemBaseProps) => {
  const { isSelected, id, children, subHeader, ...rest } = props;

  function stop(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
  }

  if (subHeader) {
    return <div className="item-single item-single--header">{children}</div>;
  }
  return (
    <div
      onMouseDown={stop}
      onMouseUp={stop}
      data-selected={isSelected}
      data-id={id}
      {...rest}
    >
      {children}
    </div>
  );
};
